export default (t) => [
  {
    text: t('Branch Code'),
    value: 'code',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Branch Name'),
    value: 'name',
    sortable: false,
    togglable: true
  },
  {
    text: t('Telephone'),
    value: 'telephone1',
    sortable: false,
    width: 200,
    togglable: true
  },
  {
    text: t('Type'),
    value: 'hq',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Active'),
    value: 'active',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Created At'),
    value: 'created_at',
    sortable: true,
    width: 150,
    togglable: true
  },
  {
    text: t('Create By'),
    value: 'created_by',
    sortable: false,
    width: 100,
    togglable: true
  },
  {
    text: t('Action'),
    value: 'action',
    sortable: false,
    width: 100
  },
];
